import type { PickupPointLocation } from 'services';

export function getPickupPointOptionId(location: PickupPointLocation): string {
  return `pickup-point-option-${location.serviceId}`;
}
